import {FC} from 'react'
import {Link} from 'react-router-dom'
import ActionButton from 'jbc-front/components/ActionButton'
import {useQuery} from 'hooks/graphql'
import {FlatCard, FlatCardBody, FlatCardHeader, FlatCardTitle} from '../FlatCard'
import {DASHBOARD_ALERTS, DashboardAlertsQueryResult} from './query'
import {ContractAlerts} from './ContractAlerts'
import {VisaAlerts} from './VisaAlerts'
import {CustomAlerts} from './CustomAlerts'
import {CommentAlerts} from './CommentAlerts'
import styles from './Alerts.scss'

export const Alerts: FC = () => {
  const {data} = useQuery<DashboardAlertsQueryResult>(DASHBOARD_ALERTS, {
    fetchPolicy: 'network-only',
  })
  if (!data) {
    return null
  }
  if (
    [
      data.client.contractAlertEmployees,
      data.client.visaAlertEmployees,
      data.client.commentAlerts.comments,
      data.employeeAlertsOnDashboard,
    ].every((array) => array.length === 0)
  ) {
    return null
  }

  return (
    <FlatCard>
      <FlatCardHeader border>
        <FlatCardTitle>アラート</FlatCardTitle>
        <ActionButton as={Link} to="/alerts">
          すべて見る
        </ActionButton>
      </FlatCardHeader>
      <FlatCardBody className={styles.cardBody}>
        <ContractAlerts employees={data.client.contractAlertEmployees} />
        <VisaAlerts employees={data.client.visaAlertEmployees} />
        <CustomAlerts employeeAlerts={data.employeeAlertsOnDashboard} />
        <CommentAlerts commentAlerts={data.client.commentAlerts} />
      </FlatCardBody>
    </FlatCard>
  )
}
